// extracted by mini-css-extract-plugin
export default {"userAvatar":"tmnb8FG39IInwyvvky1A","userAvatarContainer":"B_WslD1u3RgAlCkgxKTv","userAvatarRightNode":"N1Mm1M3RqG0zDgOx6cCU"};